import { Component } from '@angular/core'
import { YesNoCancelDialogModel } from './dialog.model'
import { CaDialogComponent } from './ca-dialog.base'

@Component({
    selector: 'ca-yes-no-cancel-dialog',
    template: `
        <div class="curtain">
            <section class="component-modalDialog redesigned" id="test-yesNoCancelDialog">
                <header>
                    {{title}}
                </header>
                <div class="contentContainer scrollable nativeScrollbar inside">
                    <div class="col-full no-height">
                        <p class="message" *ngFor="let paragraph of content">
                            {{paragraph}}
                        </p>
                    </div>
                </div>
                <footer>
                    <a class="button-primary" (click)="resolve(true)" id="dialog-yesnocancel-button-yes">{{yesLabel}}</a>
                    <a class="button-primary" (click)="resolve(false)" id="dialog-yesnocancel-button-no">{{noLabel}}</a>
                    <a class="button-secondary" (click)="resolve(null)" id="dialog-yesnocancel-button-cancel">{{cancelLabel}}</a>
                </footer>
            </section>
        </div>`,
    standalone: false
})
export class YesNoCancelDialogComponent extends CaDialogComponent<YesNoCancelDialogModel, boolean> implements YesNoCancelDialogModel {
    title: string
    content: string[]
    yesLabel: string
    noLabel: string
    cancelLabel: string

    resolve(resolution: boolean): void {
        this.result = resolution
        this.close()
    }

}